import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {catchError, Observable} from 'rxjs';
import {environment} from '../../environment/environment';
export type QueryModel = Record<string, any>;

@Injectable({providedIn: 'root'})
export class HttpService {
    constructor(
        protected http: HttpClient
    ) {
    }
    private createHeaders(): HttpHeaders {
        return new HttpHeaders({
            'Content-Type': 'application/json'
        });
    }

    private createFormDataOptions(): HttpHeaders {
        return  new HttpHeaders();
    }

    get(url: string, queryModel?: QueryModel): Observable<any> {
        let params = new HttpParams();

        // Add properties from queryModel to params
        if (queryModel) {
            Object.keys(queryModel).forEach(key => {
                if (queryModel[key] !== null && queryModel[key] !== undefined) {
                    params = params.append(key, queryModel[key].toString());
                }
            });
        }

        return this.http.get(environment.apiUrl + url, {
            headers: this.createHeaders(),
            params: params
        }).pipe(
            catchError(this.handleError)
        );
    }


    post(url: string, data: any): Observable<any> {
        return this.http.post(environment.apiUrl + url, data, { headers: this.createHeaders() })
            .pipe(
                catchError(this.handleError)
            );
    }

    put(url: string, data: any, queryModel?: QueryModel): Observable<any> {
        let params = new HttpParams();

        // Add properties from queryModel to params
        if (queryModel) {
            Object.keys(queryModel).forEach(key => {
                if (queryModel[key] !== null && queryModel[key] !== undefined) {
                    params = params.append(key, queryModel[key].toString());
                }
            });
        }
        return this.http.put(environment.apiUrl + url, data, {
            headers: this.createHeaders(),
            params: params
        }).pipe(
            catchError(this.handleError)
        );
    }
    patch(url: string, data: any, queryModel?: QueryModel): Observable<any> {
        let params = new HttpParams();

        // Add properties from queryModel to params
        if (queryModel) {
            Object.keys(queryModel).forEach(key => {
                if (queryModel[key] !== null && queryModel[key] !== undefined) {
                    params = params.append(key, queryModel[key].toString());
                }
            });
        }
        return this.http.patch(environment.apiUrl + url, data, {
            headers: this.createHeaders(),
            params: params
        }).pipe(
            catchError(this.handleError)
        );
    }

    delete(url: string): Observable<any> {
        return this.http.delete(environment.apiUrl + url, { headers: this.createHeaders() })
            .pipe(
                catchError(this.handleError)
            );
    }

    formDataPost(url: string, data: any): Observable<any> {
        return this.http.post(environment.apiUrl + url, data, {headers: this.createFormDataOptions()})
            .pipe(
                catchError(this.handleError)
            );
    }

    formDataPatch(url: string, data: any): Observable<any> {
        return this.http.patch(environment.apiUrl + url, data, {headers: this.createFormDataOptions()})
            .pipe(
                catchError(this.handleError)
            );
    }

    download(url: string, fileName: string, fileType: string, queryModel?: QueryModel): void {
        let params = new HttpParams();
        if (queryModel) {
            Object.keys(queryModel).forEach(key => {
                if (queryModel[key] !== null && queryModel[key] !== undefined) {
                    params = params.append(key, queryModel[key].toString());
                }
            });
        }
        this.http.get(environment.apiUrl + url, { responseType: 'blob', params: params }).subscribe((response: Blob) => {
            // Create a Blob with the response and the provided file type
            const blob = new Blob([response], { type: fileType });
            // Generate a URL for the blob
            const blobUrl = URL.createObjectURL(blob);

            // Trigger the download by creating an anchor element
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = fileName;
            link.click();

            // Open the PDF in a new tab if the file type is PDF
            if (fileType === 'application/pdf') {
                window.open(blobUrl, '_blank');
            }

            // Optionally, revoke the Blob URL after a short delay to free memory
            setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
        })
    }

    // A method to handle errors
    private handleError(error: any): Observable<never> {
        throw error;
    }

}
